/*
 * Copyright (c) 2026 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, inject, output, signal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { translationSchema } from '@well/translation';
import { TaskResourceService } from '@well/delivery-libs/task-management/resource-services';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { ErrorSeverityEnum } from '@irian-ro/shared-components-module';

@Component({
  selector: 'well-task-close-dialog',
  templateUrl: './task-close-dialog.component.html',
  standalone: true,
  imports: [DialogModule, ButtonModule, TranslateModule],
})
export class TaskCloseDialogComponent {
  taskResourceService = inject(TaskResourceService);
  translateService = inject(TranslateService);
  messageService = inject(MessageService);

  closed = output<void>();

  visible = signal(false);
  taskUuid = signal<string | null>(null);

  protected readonly translationSchema = translationSchema;

  open(uuid: string) {
    this.taskUuid.set(uuid);
    this.visible.set(true);
  }

  closeTask() {
    if (!this.taskUuid()) return;
    this.visible.set(false);
    this.taskResourceService.close(this.taskUuid()!).subscribe(() => {
      this.closed.emit();
      this.messageService.add({
        key: 'global-notification',
        severity: ErrorSeverityEnum.success,
        summary: 'Success',
        life: 3000,
        detail: this.translateService.instant(translationSchema.task.list.closedSuccessfully),
      });
    });
  }
}
